/**
 * AdventureConfig — single visible toggle surface for the /adventure URL.
 *
 * /adventure is the "play the actual game" card — distinct from the test
 * sandboxes (/brawl, /arena, /pve, /abilitygrounds). It boots the cozy→spooky
 * starter-island progression at its FRONT DOOR: Tidewend, the safe village hub.
 * From there the in-world portals carry the player through the chain:
 *
 *   Tidewend (village hub, no mobs) → Pig Beach (hunt pigs — now lethal) →
 *   Brackenmoor → Coil Undercroft, with Tidewend → /lobby as the graduation.
 *
 * Wiring (mirrors /pve):
 *   - main.tsx → reads on /adventure mount; injects ?map=tidewend&preset=…
 *   - data/levels/tidewend.json → geometry (registered in LevelRegistry)
 *   - content/zones/tidewend.toml → NPC placement (Elder Wynn, …). Tidewend is
 *     a SAFE hub: zero mob spawns. Pig Beach (content/zones/pig_beach.toml) is
 *     where the lethal pigs live; the player walks there via the portal.
 *
 * Class picker IS shown (no autoClass) — this is a game mode, the player picks
 * their hero. See feedback_brawl_url_canon for the canon-surface pattern.
 */

export const ADVENTURE_CONFIG = {
  // Wipe per-tab cache on first /adventure navigation (mirrors /pve). PTR has
  // no persistent accounts yet, so a clean boot avoids stale-state confusion.
  resetOnLoad: true,

  // What the player spawns as if they don't change it in the picker. Warrior
  // is the gentlest first-time melee identity for the cozy on-ramp.
  defaultClass: 'warrior' as const,

  // 'live-lobby' = clean game viewport, nameplates + HP bars on, all dev UI off.
  // The right preset for "this is the actual game", not a diagnostic surface.
  preset: 'live-lobby' as const,
  skipSplash: true,
  skipLogin: true,
} as const;
